import s from './Switch.module.scss';
import cn from 'classnames';
interface Props {
    id: string;
    lbl: string;
    isOn: boolean;
    isWide?: boolean;
    customClass?: string;
    updateState: () => void;
}
const Switch = ({
    id,
    lbl,
    isOn,
    isWide = false,
    customClass,
    updateState,
}: Props) => {
    const handleClick = () => {
        updateState();
    };
    return (
        <div
            className={cn(s.rt, {
                [s.rt_whide]: isWide,
                //@ts-ignore
                [customClass]: customClass,
            })}
        >
            <label className={s.lbl} htmlFor={id}>
                {lbl}
            </label>
            <button
                onClick={handleClick}
                id={id}
                role="switch"
                // className={`mn_switch${isOn ? ' mn_switch--active' : ''}`}
                className={cn({
                    [s.sw]: true,
                    [s.sw__act]: isOn,
                })}
                aria-checked={isOn}
            >
                <div className={s.sw_ball}></div>
            </button>
        </div>
    );
};

export default Switch;
